class MobileBottomNavigation extends HTMLElement {
  connectedCallback() {
    this.lastScrollY = Math.max(window.scrollY, 0);
    this.ticking = false;
    this.isPointerActive = false;
    this.mobileQuery = window.matchMedia('(max-width: 749px)');

    this.onScroll = this.onScroll.bind(this);
    this.onViewportChange = this.onViewportChange.bind(this);
    this.onPointerStart = this.onPointerStart.bind(this);
    this.onPointerEnd = this.onPointerEnd.bind(this);
    this.updateDocumentOffset = this.updateDocumentOffset.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.updateDocumentOffset, { passive: true });
    window.addEventListener('pointerup', this.onPointerEnd);
    window.addEventListener('pointercancel', this.onPointerEnd);
    this.mobileQuery.addEventListener('change', this.onViewportChange);
    this.addEventListener('pointerdown', this.onPointerStart);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.updateDocumentOffset);
    window.removeEventListener('pointerup', this.onPointerEnd);
    window.removeEventListener('pointercancel', this.onPointerEnd);
    this.mobileQuery?.removeEventListener('change', this.onViewportChange);
    this.removeEventListener('pointerdown', this.onPointerStart);
    this.clearDocumentOffset();
  }

  onScroll() {
    if (!this.mobileQuery.matches || this.ticking || this.isPointerActive) return;

    this.ticking = true;
    window.requestAnimationFrame(() => {
      if (this.isPointerActive) {
        this.ticking = false;
        return;
      }

      const currentScrollY = Math.max(window.scrollY, 0);
      const delta = currentScrollY - this.lastScrollY;

      if (currentScrollY <= 16) {
        this.hide();
        this.lastScrollY = currentScrollY;
      } else if (Math.abs(delta) >= 4) {
        if (delta > 0) {
          this.show();
        } else {
          this.hide();
        }

        this.lastScrollY = currentScrollY;
      }

      this.ticking = false;
    });
  }

  onPointerStart() {
    this.isPointerActive = true;
  }

  onPointerEnd() {
    if (!this.isPointerActive) return;

    this.isPointerActive = false;
    this.lastScrollY = Math.max(window.scrollY, 0);
  }

  onViewportChange(event) {
    if (!event.matches) this.hide();
    this.lastScrollY = Math.max(window.scrollY, 0);
  }

  updateDocumentOffset() {
    if (!this.mobileQuery.matches || !this.classList.contains('is-visible')) return;

    document.documentElement.style.setProperty('--mobile-bottom-navigation-height', `${this.offsetHeight}px`);
  }

  clearDocumentOffset() {
    document.documentElement.classList.remove('mobile-bottom-navigation-visible');
    document.documentElement.style.removeProperty('--mobile-bottom-navigation-height');
  }

  show() {
    this.classList.add('is-visible');
    this.removeAttribute('aria-hidden');
    this.removeAttribute('inert');
    this.updateDocumentOffset();
    document.documentElement.classList.add('mobile-bottom-navigation-visible');
  }

  hide() {
    this.classList.remove('is-visible');
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
    this.clearDocumentOffset();
  }
}

if (!customElements.get('mobile-bottom-navigation')) {
  customElements.define('mobile-bottom-navigation', MobileBottomNavigation);
}
